import { FC } from "react";
import { ReactComponent as SvgUsualTable } from "images/table.svg";
import { ReactComponent as SvgGroupTable } from "images/groups.svg";
import { useAppDispatch, useAppSelector } from "toolkit/hooks";
import { ChangeTableMode } from "toolkit/steps/stepSix/stepSix.slice";
import styles from "./ViewSwitch.module.sass";
import cn from "classnames";

export const ViewSwitch: FC = () => {
	const { tableMode } = useAppSelector((state) => state.stepSix);
	const dispatch = useAppDispatch();

	const changingViewHandler = (value: boolean) => {
		if (tableMode === value) return;
		dispatch(ChangeTableMode(value));
	};

	return (
		<div className={styles["view-switch"]}>
			<button
				onClick={() => changingViewHandler(true)}
				className={cn(styles["view-switch-btn"], tableMode && styles["view-switch-btn-active"])}>
				<SvgUsualTable />
			</button>
			<button
				onClick={() => changingViewHandler(false)}
				className={cn(styles["view-switch-btn"], !tableMode && styles["view-switch-btn-active"])}>
				<SvgGroupTable />
			</button>
		</div>
	);
};
